import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import * as fromUser from '@app/core/user/store/reducers';
import { Product } from '@vestiaire/api-sdk-angular';
import { select, Store } from '@ngrx/store';
import { IAppState } from '@app/store';

export interface ProductClick {
  product: Product;
  position: number;
}

@Component({
  selector: 'vc-products-arrangement',
  templateUrl: './products-arrangement.component.html',
  styleUrls: ['./products-arrangement.component.scss']
})
export class ProductsArrangementComponent implements OnChanges {
  @Input() items: Product[];
  @Input() seoContext: string[] = [];
  @Input() itemMax: number;
  @Input() isSlider: boolean;

  @Output() productClick = new EventEmitter<ProductClick>();

  products: Product[] = [];
  likedItem: string[] = [];
  isMdUp = false;
  eventClick: Event;
  prevClickable = false;
  nextClickable = true;
  itemMin = 4;

  constructor(private store: Store<IAppState>) {
    this.store.pipe(select(fromUser.getLikedItems)).subscribe(
      productsLiked => productsLiked && (this.likedItem = productsLiked['products']),
      error => console.error(error)
    );
    this.store.select('device').subscribe(
      device => device && (this.isMdUp = device.isMdUp),
      error => console.error(error)
    );
  }

  ngOnChanges() {
    if (this.items.length > 0 && this.itemMax) {
      const productList = this.items.slice(0, this.itemMax);
      this.products = productList;
    } else {
      this.products = this.items;
    }
  }

  scrollToNext(el: HTMLElement) {
    const left = el.scrollLeft + el.offsetWidth;
    el.scrollTo({ left, behavior: 'smooth' });
    this.prevClickable = true;
    this.nextClickable = el.clientWidth < el.offsetWidth;
  }

  scrollToPrev(el: HTMLElement) {
    const left = el.scrollLeft - el.offsetWidth;
    el.scrollTo({ left, behavior: 'smooth' });
    this.nextClickable = el.scrollLeft > 0;
    this.prevClickable = !(el.scrollLeft > 0);
  }

  onProductClick(product: Product, position: number) {
    const event: ProductClick = { product, position };
    this.productClick.emit(event);
  }
}
